// src/components/ProtectedAdminRoute.js
// Validates admin access via the backend API, not localStorage alone.
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { API } from "../config/api";

const ProtectedAdminRoute = ({ children }) => {
  const [status, setStatus] = useState("loading"); // "loading" | "ok" | "denied"

  useEffect(() => {
    const verify = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setStatus("denied");
        return;
      }

      try {
        const res = await axios.get(`${API.USERS}/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data?.role === "admin") {
          setStatus("ok");
        } else {
          setStatus("denied");
        }
      } catch {
        setStatus("denied");
      }
    };

    verify();
  }, []);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FCFAED]">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-[var(--secondary-color)] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-gray-500 text-sm">Vérification des droits...</p>
        </div>
      </div>
    );
  }

  if (status === "denied") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
